import { amber } from '@mui/material/colors';
import { PaletteOptions } from '@mui/material/styles';

const LightTheme: PaletteOptions = {
    primary: amber
}

export default LightTheme